export function isValid(url)
{
	return url.startsWith('http://') || url.startsWith('https://');
}